var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-detail"},[_c('NewsHeader',{attrs:{"data":_vm.data}}),_c('NewsInfo',{attrs:{"data":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }